// http://www.java2s.com/Code/Java/Network-Protocol/enumMimeType.htm
// https://docs.aws.amazon.com/AWSJavaSDK/latest/javadoc/com/amazonaws/services/s3/internal/Mimetypes.html
// Use ''.includes(mimetype['']) to check mimetype,
// May have optional charset: "image/jpeg;charset=utf-8"
export const mimeType = Object.freeze({
  '.pdf': 'application/pdf',
  '.rtf': 'application/rtf',
  '.json': 'application/json',
  '.js': 'application/javascript',

  '.png': 'image/png',
  '.jpg': 'image/jpeg',
  '.jpe': 'image/jpeg',
  '.jpeg': 'image/jpeg',
  '.svg': 'image/svg+xml',
  '.tif': 'image/tiff',
  '.tiff': 'image/tiff',
  '.webp': 'image/webp',
  '.bmp': 'image/bmp',
  '.gif': 'image/gif',

  '.css': 'text/css',
  '.csv': 'text/csv',
  '.htm': 'text/html',
  '.html': 'text/html',

  '.txt': 'text/plain',
})

export const getFileExtensionByMimeType = mimeTypeString => {
  return Object.keys(mimeType).find(key => mimeTypeString.includes(mimeType[key])) ?? ''
}
